import React from "react";

import PageTitle from "../../components/PageTitle";
import './Works.css';

const Works = () => {
  const handleCopy = () => {
    const realEmail = "adzuki_info@adzuki-world.com";

    if (navigator.clipboard && navigator.clipboard.writeText) {
      // HTTPS環境やlocalhostで利用可能な最新のAPI
      navigator.clipboard.writeText(realEmail).then(() => {
        alert("メールアドレスをコピーしました！");
      }).catch(err => {
        console.error("Clipboard copy failed", err);
      });
    } else {
      // HTTP環境や古いブラウザ向けのフォールバック
      const textArea = document.createElement("textarea");
      textArea.value = realEmail;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        alert("メールアドレスをコピーしました！");
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
	<div>
		<div className="works-page-wrapper" />
		<PageTitle title={"Works"} />

		<h1 className="top-title">Works</h1>
		<p className="header-comment">Adzuki.にお仕事を依頼出来るページです。</p>


		<div className="stats-area">
			<hr/>
			<h2>Stats</h2>
			<p>かなり空いてます<br/>
			   (2026/05/04 現在)
			</p>
			
		</div>

		<div className="Request-area">
			<hr/>
			<h2>Request</h2>
			<a href="https://skeb.jp/@a_d_z_u_k_i_">Skeb</a>
			<a href="https://www.pixiv.net/users/13909150/request">Pixiv Request</a>
			<a href="https://skima.jp/profile?id=515371">SKIMA</a>
			
		</div>

		
		<div className="contact-area">
			<hr/>
			<p>上記のサービス外でのご依頼の場合はこちらになります。<br/></p>
			<p>お支払い方法は銀行振込、またはPayPal等になります。<br/></p>
			<p>※ご不安の場合、上記のサービスをご利用して頂く事を推奨します。</p>
			<h2>料金体系</h2>

			<table>
				<tbody>
					<tr>
						<th>品目</th>
						<th>価格</th>
						<th>納品目安</th>
						<th>リテイク</th>
						<th>備考</th>
					</tr>
					<tr>
						<td>アイコン</td>
						<td>5,000円</td>
						<td>1～2週間</td>
						<td>1回まで</td>
						<td>1000×1000の真四角のサイズになります。</td>
					</tr>
					<tr>
						<td>イラスト</td>
						<td>8,000～10,000円</td>
						<td>1～3週間</td>
						<td>2回まで</td>
						<td>キャラ1人のイラストです。(デフォルメキャラに限ります)</td>
					</tr>
					<tr>
						<td>一枚絵</td>
						<td>15,000～25,000円</td>
						<td>1～4週間</td>
						<td>4回まで</td>
						<td>キャラクターは10人まで。(デフォルメキャラに限ります)</td>
					</tr>
				</tbody>
			</table>

		</div>

		<div className="forminfo-area">
			<h2>CONTACT</h2>
			<p>ご依頼や、当HP関連についてのお問い合わせは<br/>
			以下のフォームか、メールアドレスにて承ります。<br/></p>

		</div>

		<div className="mail" onClick={handleCopy} title="クリックしてコピー">
			<span className="mail-text">
				adzuki_info(a)adzuki-world.com
			</span>
		</div>

		<div className="form-area">
			<a href="https://forms.gle/rXQpHPYJwfAEZ5Yk6">問い合わせ(Googleフォーム)</a>
			<iframe 
				src="https://docs.google.com/forms/d/e/1FAIpQLSeH7B6W-j0f95-kA_D7kPRTDoj8q046PuptSLiQ1LzhMsMZwg/viewform?embedded=true" 
				width="100%" 
				height="1200" 
				title="お問い合わせフォーム"
			>
				読み込んでいます…
			</iframe>
		</div>

	</div>
  );
};

export default Works;